import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useSiteDevices = (siteId) => {
  const { data: allAlarms } = useSelector((state) => state.alarms);
  const { data: allLoggers, loading: loggerLoading } = useSelector(
    (state) => state.loggers
  );
  const { data: allMeters, loading: meterLoading } = useSelector(
    (state) => state.meters
  );
  const { data: allInverters, loading: inverterLoading } = useSelector(
    (state) => state.inverters
  );
  const { data: allSensors, loading: sensorLoading } = useSelector(
    (state) => state.sensors
  );

  const [meters, meterIds] = useMemo(() => {
    const _meters = allMeters.filter((meter) => meter.site_id === siteId);
    const _meterIds = _meters.map((meter) => meter.meter_id);
    return [_meters, _meterIds];
  }, [allMeters, siteId]);

  const loggers = useMemo(
    () => allLoggers.filter((logger) => logger.site_id === siteId),
    [allLoggers, siteId]
  );

  const inverters = useMemo(
    () =>
      allInverters.filter((inverter) => meterIds.includes(inverter.meter_id)),
    [allInverters, meterIds]
  );

  const sensors = useMemo(
    () => allSensors.filter((sensor) => meterIds.includes(sensor.meter_id)),
    [allSensors, meterIds]
  );

  const alarms = useMemo(() => {
    const deviceIds = [
      siteId,
      ...meterIds,
      ...loggers.map((logger) => logger.logger_id),
      ...inverters.map((inverter) => inverter.inverter_id),
      ...sensors.map((sensor) => sensor.sensor_id),
    ];
    return allAlarms.filter((alarm) => deviceIds.includes(alarm.device_id));
  }, [siteId, meterIds, loggers, inverters, sensors, allAlarms]);

  return {
    loggers,
    meters,
    inverters,
    sensors,
    alarms,
    loading: loggerLoading || meterLoading || inverterLoading || sensorLoading,
  };
};

export default useSiteDevices;
